module.exports = __webpack_public_path__ + "media/images/button_share-c4b2a4707dc855e20362740552a2608f.png";